import {
  HouseIcon,
  SearchIcon,
  PersonGroupIcon,
  WorkspaceIcon,
  CollectionIcon,
  TroubleshootIcon,
  PaperPlaneIcon,
  ProcessingIcon,
  GearIcon,
  SupportIcon,
  AiGenFillIcon,
} from '@design-systems/react-icons'
import { SINGLE_PLAYGROUND_VIEW_AI } from '../constants/routes'

/**
 * sideNavConfig
 *
 * Single source of truth for the AssetHub primary side-navigation items.
 *
 * Each entry is shaped as a Canvas 8 `PrimaryMenuItem`:
 *   {
 *     id           {string}            unique key, must match the roleName used by isAuthorizedToPage()
 *     label        {string}            human-readable text shown in the nav
 *     icon         {React.FC}          icon component from @design-systems/react-icons
 *     redirectionUrl {string}          react-router path — used to build the `as / props` polymorphic entry
 *     isActive     {boolean}           dynamically overridden at render time by useActiveNavTab()
 *     badge        {IMenuItemBadge}    optional — shows a badge pill on the item
 *   }
 *
 * The `redirectionUrl` field is AssetHub-specific and consumed by AHSideNavCanvas to
 * attach React Router's <Link> via the Canvas 8 `as` / `props` polymorphic pattern.
 *
 * NOTE: Canvas 8 icons come from @design-systems/react-icons.
 */
export const sideNavConfig = [
  {
    id: 'home',
    label: 'Home',
    icon: HouseIcon,
    redirectionUrl: '/',
  },
  {
    id: 'search',
    label: 'Search',
    icon: SearchIcon,
    redirectionUrl: '/search',
  },
  {
    id: 'groups',
    label: 'Groups',
    icon: PersonGroupIcon,
    redirectionUrl: '/groups',
  },
  {
    id: 'projects',
    label: 'Projects',
    icon: WorkspaceIcon,
    redirectionUrl: '/projects',
  },
  {
    id: 'boards',
    label: 'Boards',
    icon: CollectionIcon,
    redirectionUrl: '/boards',
  },
  {
    id: 'usageRights',
    label: 'Usage Rights',
    icon: TroubleshootIcon,
    redirectionUrl: '/usageRights',
  },
  {
    id: 'ai_imagetotext',
    label: 'AI',
    icon: AiGenFillIcon,
    redirectionUrl: SINGLE_PLAYGROUND_VIEW_AI,
  },
  // ASSETHUB-17275: Removed Classification from the side nav as per the new design. Keeping the code commented for future reference.
  // {
  //   id: 'classification',
  //   label: 'Classification',
  //   icon: TemplateIcon,
  //   redirectionUrl: '/classification',
  // },
  {
    id: 'publish',
    label: 'Publishing',
    icon: PaperPlaneIcon,
    redirectionUrl: '/publishing',
  },
  {
    id: 'assetLifecycleDashboard',
    label: 'Lifecycle',
    icon: ProcessingIcon,
    redirectionUrl: '/asset-lifecycle-dashboard',
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: GearIcon,
    redirectionUrl: '/settings',
  },
  {
    id: 'help',
    label: 'Help',
    icon: SupportIcon,
    redirectionUrl: '/help',
  },
]
